import { ODataObject } from '../../interfaces/odata-model.interface';
import { CompositeModel } from '../complex/composite.model';

export class EncryptionKeyModel extends CompositeModel {
    public constructor(
        public userName: string,
        public encryptedKey: string,
    ) {
        super('EncryptionKeyModel', {});
    }

    public static fromOData(data: ODataEncryptionKeyModel): EncryptionKeyModel {
        return new EncryptionKeyModel(data.UserName, data.EncryptedKey);
    }
}

export interface ODataEncryptionKeyResponse {
    d: {
        results: ODataEncryptionKeyModel[];
    };
}

export interface ODataEncryptionKeyModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.EncryptionKey';
    };
    UserName: string;
    EncryptedKey: string;
}
